module.exports = require('./helpers/bundle-url').getBundleURL('8X01H') + "logo.c51670a8.svg";